module.exports = __webpack_public_path__ + "img/18_108.ce65f765.png";